module.exports = __webpack_public_path__ + "img/parodemotor.4432e388.png";